import { nonEmptyArray } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useMemo } from 'react';
import { ReservationState, ReservationSummary } from '@mews-commander/guest-profile';

export const useGetReservationsSections = (reservations: Array<ReservationSummary>) =>
    useMemo(
        () =>
            pipe(
                reservations,
                nonEmptyArray.groupBy<ReservationSummary>((reservation) => reservation.reservationState),
                (sorted) => ({
                    [ReservationState.Active]: sorted[ReservationState.Active] || [],
                    [ReservationState.Canceled]: sorted[ReservationState.Canceled] || [],
                    [ReservationState.Past]: sorted[ReservationState.Past] || [],
                })
            ),
        [reservations]
    );
